import { render, staticRenderFns } from "./AdministrativeData.vue?vue&type=template&id=250935bb&"
import script from "./AdministrativeData.vue?vue&type=script&lang=js&"
export * from "./AdministrativeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports